export const messages = {
  en: {
    roleShop: {
      title: 'Shop Authorization',
      shopId: 'Shop ID',
      shopName: 'Shop Name',
      shopAddress: 'Shop Address',
      operation: 'Operation',
      addShop: 'Add Shop',
      deleteShop: 'Delete Shop',
      searchPlaceholder: 'Enter shop name',
      confirmDelete: 'Are you sure to cancel authorization?',
      selectShopTip: 'Please select shop',
      addSuccess: 'Add shop successfully',
      deleteSuccess: 'Delete shop successfully'
    }
  },
  zh: {
    roleShop: {
      title: '店铺授权',
      shopId: '店铺编号',
      shopName: '店铺名称',
      shopAddress: '店铺地址',
      operation: '操作',
      addShop: '关联店铺',
      deleteShop: '删除店铺',
      searchPlaceholder: '输入店铺名称',
      confirmDelete: '确定取消授权吗？',
      selectShopTip: '请选择店铺',
      addSuccess: '关联店铺成功',
      deleteSuccess: '删除店铺成功'
    }
  }
}